"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var StarInverted = function StarInverted(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "10.8",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(1,1)"
    // eslint-disable-next-line max-len
    ,
    d: "M0 10C0 4.48 4.47 0 9.99 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 9.99 20C4.47 20 0 15.52 0 10ZM10 13.45L14.23 16L13.11 11.18L16.84 7.95L11.92 7.53L10 3L8.08 7.54L3.16 7.96L6.89 11.19L5.77 16L10 13.45Z",
    fill: "#75767A"
  }, colorStyles)));
};
StarInverted.propTypes = _inline_svg2.default.propTypes;
StarInverted.defaultProps = _inline_svg2.default.defaultProps;
var _default = StarInverted;
exports.default = _default;